var map = {
	"./2022 Ultrafast modulation of vibrational polaritons for controlling the quantum field statistics at mid-infrared frequencies.pdf": 3982,
	"./AFOSR.png": 2890,
	"./Miroscopio2-youtube.png": 6751,
	"./QKD-demo-talk-ES-V2.pdf": 9198,
	"./cv/cvfelipe.pdf": 7803,
	"./displaced-potential-cavity.jpeg": 7048,
	"./driven-polar-molecules.jpeg": 1857,
	"./einstein-thesis.jpeg": 2263,
	"./felipeherrera headshot.png": 5095,
	"./felipeherrera.jpg": 1306,
	"./fherrera-old.jpg": 2253,
	"./fherrera.jpg": 4610,
	"./funding-banner.png": 6706,
	"./group-april-2022.jpg": 1622,
	"./group-aug-2023.jpg": 7624,
	"./group-sep-2019.jpg": 9162,
	"./group_news_images/2022_AnisotropicBandEdge.pdf": 5538,
	"./group_news_images/JCP-most-read-2020.jpg": 6730,
	"./group_news_images/bastian-simon-ricky.jpeg": 1463,
	"./group_news_images/bmartinez-pic.jpeg": 1807,
	"./group_news_images/defensa-felipe-recabal.jpg": 4850,
	"./group_news_images/defensa-gaston-gonzalez.jpg": 9044,
	"./group_news_images/defensa-ivan-jara.jpg": 3769,
	"./group_news_images/defensa-simon-paiva.png": 4741,
	"./group_news_images/federico-prize.jpg": 7028,
	"./group_news_images/fernanda_veliz.png": 2115,
	"./group_news_images/fondecyt-logo.jpg": 2830,
	"./group_news_images/frecabal.jpg": 9010,
	"./group_news_images/ichi.jpg": 3466,
	"./group_news_images/johan-triana-talk.jpeg": 9517,
	"./group_news_images/jonathan-sepulveda.png": 1446,
	"./group_news_images/katy-pic.jpg": 3132,
	"./group_news_images/mauricio-arias-visit.jpg": 6257,
	"./group_news_images/mqt-home-screenshot.jpg": 9289,
	"./group_news_images/mqt2022-announcement.jpeg": 2685,
	"./group_news_images/msilva-pic.jpeg": 5803,
	"./group_news_images/royal_society.png": 7115,
	"./group_news_images/shanavas-farewell.jpg": 5937,
	"./group_news_images/thulasi-profile.png": 6093,
	"./group_news_images/universityofwaterloo_logo.jpg": 4960,
	"./group_news_images/vanessa-olaya-screenshot.jpg": 6866,
	"./icon-logo.png": 486,
	"./icon_generic.png": 8448,
	"./logo.png": 2179,
	"./mof-photon-entanglement.jpeg": 6378,
	"./mof-shg.jpeg": 7952,
	"./papers/2008 Magnetic-field-induced interference of scattering states in ultracold collisions.pdf": 4088,
	"./papers/2010 External field control of collective spin excitations in an optical lattice of 2-sigma molecules.pdf": 9373,
	"./papers/2010 Tunable disorder in a crystal of cold polar molecules.pdf": 236,
	"./papers/2011 Tunable Holstein model with cold polar molecules.pdf": 7511,
	"./papers/2013 Investigating Polaron Transitions with Polar Molecules.pdf": 7698,
	"./papers/2014 Infrared-matchgate.pdf": 8092,
	"./papers/2014 KMM_Submitted.pdf": 1409,
	"./papers/2014 Quantum nonlinear optics with polar J-aggregates.pdf": 6374,
	"./papers/2015 Synchronization of interacting quantum dipoles.pdf": 2719,
	"./papers/2016 Cavity-controlled chemistry in molecular ensembles.pdf": 982,
	"./papers/2016 Efficient photon triplet generation in integrated nanophotonic waveguides.pdf": 6799,
	"./papers/2017 (ASAP) Theory of Nanoscale Organic Cavities The Essential Role of Vibration-Photon Dressed States.pdf": 6798,
	"./papers/2017 Absorption and photoluminescence in organic cavity QED.pdf": 5166,
	"./papers/2017 Dark Vibronic Polaritons and the Spectroscopy of Organic Microcavities.pdf": 1778,
	"./papers/2018 molecular crystal.pdf": 6444,
	"./papers/2018 pH-Controlled Assembly of 3D and 2D Zinc-Based Metal-Organic Frameworks with Tetrazole Ligands.pdf": 8786,
	"./papers/2019 An instrument-free demonstration of quantum key distribution for high-school students.pdf": 1118,
	"./papers/2019 Azide-based high-energy metal-organic frameworks with enhanced thermal stability.pdf": 4332,
	"./papers/2019 Controlled Growth of the Noncentrosymmetric Zn(3-ptz)2 and Zn(OH)(3-ptz) Metal–Organic Frameworks.pdf": 49,
	"./papers/2019 Correlative Dark-Field and Photoluminescence Spectroscopy of Individual Plasmon−Molecule Hybrid Nanostructures in a Strong Coupling Regime.pdf": 6126,
	"./papers/2019 Multi-level quantum Rabi model for anharmonic vibrational polaritons.pdf": 1719,
	"./papers/2019 Vacuum-enhanced optical nonlinearities with disordered molecular photoswitches.pdf": 8590,
	"./papers/2020 C6 coefficients for interacting Rydberg atoms and alkali-metal dimers.pdf": 8132,
	"./papers/2020 Molecular polaritons for controlling chemistry with quantum optics.pdf": 2292,
	"./papers/2020 Photochemistry with Quantum Optics from a Non-Adiabatic Quantum Trajectory Perspective.pdf": 7209,
	"./papers/2020 The shape of the electric dipole function determines the sub-picosecond dynamics of anharmonic vibrational polaritons.pdf": 2477,
	"./papers/2021 Engineering entangled photon pairs with metal– organic frameworks.pdf": 9205,
	"./papers/2021 Excited-state vibration-polariton transitions and dynamics in nitroprusside.pdf": 7412,
	"./papers/2021 Millimeter-Scale Zn(3-ptz)2 Metal−Organic Framework Single Crystals Self-Assembly Mechanism and Growth Kinetics.pdf": 254,
	"./papers/2022 Agar Biopolymer Films for Biodegradable Packaging A Reference Dataset for Exploring the Limits of Mechanical Performance.pdf": 6885,
	"./papers/2022 Disordered ensembles of strongly coupled single-molecule plasmonic picocavities as nonlinear optical metamaterials.pdf": 3421,
	"./papers/2022 Open quantum dynamics of strongly coupled oscillators with multi-configuration time dependent Hartree propagation and Markovian quantum jumps.pdf": 5025,
	"./papers/2022 Semi-empirical quantum optics for mid-infrared molecular nanophotonics.pdf": 6505,
	"./papers/2022 Ultrafast modulation of vibrational polaritons for controlling the quantum field statistics at mid-infrared frequencies.pdf": 968,
	"./papers/2022_AnisotropicBandEdge.pdf": 5664,
	"./papers/2023 Antenna-coupled infrared nanospectroscopy of intramolecular vibrational interaction.pdf": 5055,
	"./papers/2023 Machine Learning Identification of Organic Compounds Using Visible Light.pdf": 653,
	"./papers/2023 Model reduction for molecular diffusion in nanoporous media.pdf": 311,
	"./papers/2023 Modification of ground-state chemical reactivity via light–matter coherence in infrared cavities.pdf": 3847,
	"./papers/2023 Phase-Coherent Optical Frequency Up-Conversion with Millimeter-Size Zn(3-ptz)2 Metal-Organic Framework Single Crystals.pdf": 7515,
	"./papers/2023 Semi-empirical Haken–Strobl model for molecular spin qubits.pdf": 6880,
	"./papers/2023 Understanding the Correlation Between Structure and Entangled Photon Pair Properties with Metal-Organic Frameworks.pdf": 2461,
	"./papers/2024 Coherent anharmonicity transfer from matter to light in the THz regime.pdf": 2288,
	"./papers/2024 Efficient generation of polarization-entangled photons in metal-organic framework waveguides.pdf": 6762,
	"./papers/2024 First-principles screening of metal–organic frameworks for entangled photon pair generation.pdf": 2087,
	"./papers/2024 Molecular Strong Coupling and Cavity Finesse.pdf": 8528,
	"./papers/2024 Multiple interacting photonic modes in strongly coupled organic microcavities.pdf": 487,
	"./papers/2025 Detecting zero-point fluctuations with stochastic Brownian oscillators.pdf": 7702,
	"./papers/2025 Modeling the P3HT microcavity reflectance spectrum Introducing a partitioning scheme for treating large disordered chromophore ensembles.pdf": 923,
	"./papers/2025 Seaweed-Based Bioplastics Data Mining Ingredient–Property Relations from the Scientific Literature.pdf": 7861,
	"./papers/2025 Spontaneous single-molecule dissociation in infrared nanocavities.pdf": 4528,
	"./papers/2025 Ultracold long-range van der Waals Rydberg trimers.pdf": 784,
	"./papers/2026 Enhancing Infrared-Laser Dissociation of Molecules with the Electromagnetic Vacuum.pdf": 7190,
	"./papers/2026 Hybrid Atomistic-Parametric Decoherence Model for Molecular Spin Qubits.pdf": 789,
	"./papers/2026 Lindblad theory for incoherently-driven electron transport in molecular nanojunctions.pdf": 1932,
	"./people/FernandaVeliz.jpg": 7743,
	"./people/JohanTriana.jpg": 4545,
	"./people/KatyArauchan.jpeg": 3336,
	"./people/adrianrubio.jpeg": 6898,
	"./people/andreaalarcon.jpeg": 3724,
	"./people/athulsivan.jpg": 8412,
	"./people/bastianMartinez.jpg": 6034,
	"./people/felipeRecabal.jpg": 5544,
	"./people/felipeosorio.jpeg": 1839,
	"./people/gastongonzalez.jpeg": 6471,
	"./people/mauricioArias.jpeg": 3789,
	"./people/osmararavena.jpeg": 5941,
	"./people/rubenfritz.jpeg": 3058,
	"./people/samirdas.jpg": 9797,
	"./people/simonpaiva.jpeg": 892,
	"./quantum-outreach.png": 253,
	"./resources/QKD-demo-talk-ES-V2.pdf": 5122,
	"./resources/msc-thesis-frecabal.pdf": 8632,
	"./resources/msc-thesis-ggonzalez.pdf": 3395,
	"./resources/msc-thesis-jsepulveda.pdf": 8308,
	"./resources/msc-thesis-spaiva.pdf": 1972,
	"./resources/phd-thesis-marias.pdf": 7650,
	"./resources/thesis-aalarcon.pdf": 470,
	"./resources/thesis-bmartinez.pdf": 5516,
	"./resources/thesis-dcarvajal.pdf": 2141,
	"./resources/thesis-fosorio.pdf": 2112,
	"./resources/thesis-frecabal.pdf": 7537,
	"./resources/thesis-fveliz.pdf": 4122,
	"./resources/thesis-ggonzalez.pdf": 5850,
	"./resources/thesis-ijara.pdf": 3238,
	"./resources/thesis-jsepulveda.pdf": 1,
	"./resources/thesis-spaiva.pdf": 7722,
	"./resources/thesis-volaya.pdf": 836
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9211;